import "../Styles/main.scss";
import "./index.scss";
import "../../components/cmsShared";
import { Slick } from "@/pages/vendors/vendor.slick";

$(function () {
    function initTopicPostBannerSlides($topicPostBannerSlides: JQuery) {
        if ($topicPostBannerSlides.find("m-topicpost-detail__info-slide-imgs-item").length) {
            new Slick($topicPostBannerSlides, {
                swipe: true,
                dots: false,
                autoplay: true,
                infinite: true,
                speed: 500,
                fade: false,
                arrows: false,
            });
        }
    }
    const $topicPostBannerSlides = $("m-topicpost-detail__info-slide-imgs");
    initTopicPostBannerSlides($topicPostBannerSlides);
});
